import api from './api';

export const platformExpenseApi = {
    async getAll(params?: { vendorId?: string; category?: string; limit?: number; offset?: number }) {
        const response = await api.get('/admin/platform-expenses', { params });
        return response.data;
    },

    async create(data: {
        vendorId: string;
        title: string;
        category: string;
        amount: number;
        periodStart: string;
        periodEnd: string;
        description?: string;
    }) {
        const response = await api.post('/admin/platform-expenses', data);
        return response.data;
    },

    async update(id: string, data: Partial<{
        title: string;
        category: string;
        amount: number;
        periodStart: string;
        periodEnd: string;
        description: string;
    }>) {
        const response = await api.put(`/admin/platform-expenses/${id}`, data);
        return response.data;
    },

    async remove(id: string) {
        const response = await api.delete(`/admin/platform-expenses/${id}`);
        return response.data;
    },
};
